<p-carousel #pCarousel [value]="slides" [showNavigators]="true" [numVisible]="slidesOnScreenDefault" [numScroll]="1" [responsiveOptions]="responsiveOptions" [showIndicators]="false">
  <ng-template pTemplate="item" let-slide>
    <ng-container *ngTemplateOutlet="slideTemplate; context: {$implicit: slide}"></ng-container>
  </ng-template>
</p-carousel>
